export const SITE_PAGES = [
	{
		pathname: "/",
		seoKey: "home",
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "weekly",
		priority: 1,
	},
	{
		pathname: "/about",
		seoKey: "about",
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.7,
	},
	{
		pathname: "/privacy",
		seoKey: "privacy",
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "yearly",
		priority: 0.3,
	},
	{
		pathname: "/terms",
		seoKey: "terms",
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "yearly",
		priority: 0.3,
	},
	{
		pathname: "/tools/video-converter",
		seoKey: "videoConverter",
		tool: {
			navigationKey: "videoConverter",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/video-to-gif",
		seoKey: "videoToGif",
		tool: {
			navigationKey: "videoToGif",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/resize-video",
		seoKey: "resizeVideo",
		tool: {
			navigationKey: "resizeVideo",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/screen-recorder",
		seoKey: "screenRecorder",
		tool: {
			navigationKey: "screenRecorder",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/crop-video",
		seoKey: "cropVideo",
		tool: {
			navigationKey: "cropVideo",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/rotate-video",
		seoKey: "rotateVideo",
		tool: {
			navigationKey: "rotateVideo",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/tools/video-compressor",
		seoKey: "videoCompressor",
		tool: {
			navigationKey: "videoCompressor",
		},
		localeAvailability: "all",
		indexable: true,
		includeInSitemap: true,
		changeFrequency: "monthly",
		priority: 0.8,
	},
	{
		pathname: "/projects",
		seoKey: "projects",
		localeAvailability: "all",
		indexable: false,
		includeInSitemap: false,
		changeFrequency: "monthly",
		priority: 0,
	},
	{
		pathname: "/editor/[project_id]",
		seoKey: "editor",
		localeAvailability: "all",
		indexable: false,
		includeInSitemap: false,
		changeFrequency: "monthly",
		priority: 0,
	},
] as const;

export type SitePage = (typeof SITE_PAGES)[number];
export type SitePathname = SitePage["pathname"];
export type StaticSitePathname = Exclude<SitePathname, "/editor/[project_id]">;
export type SiteSeoKey = SitePage["seoKey"];
export type SiteTool = Extract<SitePage, { tool: unknown }>;

export function isPageAvailableInLocale({
	page,
	locale,
}: {
	page: SitePage;
	locale: string;
}): boolean {
	return page.localeAvailability === "all" || locale === "en";
}

export const SITEMAP_PAGES = SITE_PAGES.filter(
	(page) => page.indexable && page.includeInSitemap,
);

export const SITE_TOOLS = SITE_PAGES.filter(
	(page): page is SiteTool => "tool" in page,
);

export function getSiteTools(locale: string): SiteTool[] {
	return SITE_TOOLS.filter((page) => isPageAvailableInLocale({ page, locale }));
}
